// Assessment state types and actions

export interface AssessmentState {
  assessmentId: string | null;
  responses: Record<string, any>;
  minutesLeft: number;
  status: 'started' | 'completed' | 'abandoned' | null;
}

export const SET_ASSESSMENT_ID = 'SET_ASSESSMENT_ID';
export const SET_RESPONSE = 'SET_RESPONSE';
export const SET_RESPONSES = 'SET_RESPONSES';
export const UPDATE_MINUTES_LEFT = 'UPDATE_MINUTES_LEFT';
export const SET_STATUS = 'SET_STATUS';
export const CLEAR_RESPONSES = 'CLEAR_RESPONSES';

interface SetAssessmentIdAction {
  type: typeof SET_ASSESSMENT_ID;
  payload: string;
}

interface SetResponseAction {
  type: typeof SET_RESPONSE;
  payload: { key: string; value: any };
}

interface SetResponsesAction {
  type: typeof SET_RESPONSES;
  payload: Record<string, any>;
}

interface UpdateMinutesLeftAction {
  type: typeof UPDATE_MINUTES_LEFT;
  payload: number;
}

interface SetStatusAction {
  type: typeof SET_STATUS;
  payload: 'started' | 'completed' | 'abandoned';
}

interface ClearResponsesAction {
  type: typeof CLEAR_RESPONSES;
}

export type AssessmentActionTypes =
  | SetAssessmentIdAction
  | SetResponseAction
  | SetResponsesAction
  | UpdateMinutesLeftAction
  | SetStatusAction
  | ClearResponsesAction;
